const STACKED_SLIDER_BREAKPOINT = 1200;
let productMediaSwipers = [];
let stackedResizeBound = false;

function initProductGallery() {
  if (typeof Swiper === "undefined") return;

  var swiperEls = document.querySelectorAll(
    ".product.grid .product__media.swiper"
  );
  if (!swiperEls.length) return;

  productMediaSwipers = [];
  swiperEls.forEach(function (swiperEl) {
    if (swiperEl.classList.contains("swiper-initialized")) return;
    var paginationEl = swiperEl.querySelector(".swiper-pagination");
    var nextEl = swiperEl.querySelector(".swiper-button-next");
    var prevEl = swiperEl.querySelector(".swiper-button-prev");
    var instance = new Swiper(swiperEl, {
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      preventInteractionOnTransition: true,
      effect: "fade",
      fadeEffect: { crossFade: true },
      pagination: paginationEl
        ? { el: paginationEl, type: "bullets", clickable: true }
        : false,
      navigation: nextEl && prevEl ? { nextEl, prevEl } : false,
      allowTouchMove: true,
      simulateTouch: true,
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
    });
    productMediaSwipers.push(instance);
  });

  var isStacked =
    swiperEls[0] && swiperEls[0].classList.contains("product__media--stacked");
  if (isStacked && !stackedResizeBound) {
    stackedResizeBound = true;
    window.addEventListener("resize", function onResize() {
      if (window.innerWidth <= STACKED_SLIDER_BREAKPOINT && productMediaSwipers.length === 0) {
        initProductGallery();
      }
    });
  }
}

function runProductGallery() {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initProductGallery);
  } else {
    initProductGallery();
  }
  window.addEventListener("load", function () {
    var any = document.querySelector(
      ".product.grid .product__media.swiper:not(.swiper-initialized)"
    );
    if (any) initProductGallery();
  });
}
runProductGallery();

const instafeed = new Swiper(".instafeed", {
  slidesPerView: 1.5,
  watchOverflow: false,
  watchSlidesVisibility: true,
  spaceBetween: 16,
  navigation: {
    nextEl: ".instafeed__buttons .swiper-button-next",
    prevEl: ".instafeed__buttons .swiper-button-prev",
  },
  breakpoints: {
    600: {
      slidesPerView: 3,
      spaceBetween: 24,
    },
  },
});

const htmlTag = document.querySelector("html");
const toggleNav = document.querySelector("#hamburger");

if (toggleNav) {
  toggleNav.addEventListener("click", function (event) {
    htmlTag.classList.toggle("menu-open");
  });
}

const header = document.querySelector(".template--index .section-header");

const toggleHeader = function () {
  const pixels = window.pageYOffset;

  if (pixels > 80) {
    header.classList.add("white");
  } else {
    header.classList.remove("white");
  }
};

if (header) {
  toggleHeader();

  document.addEventListener("scroll", function () {
    toggleHeader();
  });
}
